import { render, staticRenderFns } from "./product_details_three.vue?vue&type=template&id=c3be97c8&scoped=true&"
import script from "./product_details_three.vue?vue&type=script&lang=js&"
export * from "./product_details_three.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3be97c8",
  null
  
)

export default component.exports